import { Capacitor } from "@capacitor/core";

// Lot 703 — fluidité Android : pose la classe `plat-android` sur <html> UNIQUEMENT dans l'app native Android.
// index.css s'en sert pour remplacer les flous d'arrière-plan (backdrop-filter) et les grandes ombres par des fonds
// pleins ; iOS et le web ne portent jamais cette classe → leur apparence est strictement inchangée.
export const QA_KEY = "yalola.qa_plat_android"; // aperçu web (hors production) : localStorage[QA_KEY] = "1"

export const isAndroidNative = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android";

const qaForced = () => {
  if (process.env.NODE_ENV === "production") return false;
  try { return localStorage.getItem(QA_KEY) === "1"; } catch { return false; }
};

export function installPlatformClass(doc = document) {
  const on = isAndroidNative() || qaForced();
  doc.documentElement.classList.toggle("plat-android", on);
  return on;
}

export default installPlatformClass;
